/**
 * 入口文件
 * 
 * 版本: 1.1.0
 * 变更记录:
 * - 2025-09-29: 调整初始化顺序，先安装错误处理再启用控制台敏感信息掩码；添加版本头与变更记录
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import { secureConsole } from './utils/consoleSecurity';
import { generateAndSetFavicon } from './utils/favicon';
import { setupErrorHandlers } from './utils/errorHandlers_v2';

// 先安装错误处理器（包装现有 console 方法）
setupErrorHandlers();

// 再启用控制台安全（敏感信息掩码处于最外层）
secureConsole();

// 生成并设置favicon
generateAndSetFavicon();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 